<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14 4.53524C14 4.20088 13.8329 3.88865 13.5547 3.70319L8.5547 0.369854C8.2188 0.145921 7.7812 0.145921 7.4453 0.369854L2.4453 3.70319C2.1671 3.88865 2 4.20088 2 4.53524V14.0005C2 14.5528 2.44772 15.0005 3 15.0005H13C13.5523 15.0005 14 14.5528 14 14.0005V4.53524ZM10 11.0001C10 10.4478 9.55228 10.0001 9 10.0001H7C6.44772 10.0001 6 10.4478 6 11.0001V15.0001H10V11.0001ZM10 6.02496C10.2761 6.02496 10.5 6.24881 10.5 6.52496C10.5 6.8011 10.2761 7.02496 10 7.02496H6C5.72386 7.02496 5.5 6.8011 5.5 6.52496C5.5 6.24881 5.72386 6.02496 6 6.02496H10Z"
  />
</template>
